import { EditMeetingInfoModal } from "./EditMeetingInfoModal";

export default EditMeetingInfoModal;
